import { render } from "./LimitsPage.vue?vue&type=template&id=171dda12&scoped=true"
import script from "./LimitsPage.vue?vue&type=script&lang=js"
export * from "./LimitsPage.vue?vue&type=script&lang=js"

import "./LimitsPage.vue?vue&type=style&index=0&id=171dda12&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171dda12"]])

export default __exports__